<template lang="pug">
  .profile-page__main
    .profile-page__body
      .admin-registry
        .admin-registry__controls
          .form
            //.form__elem
              //simple-select-form(
              //:list-data="managementFormsListData"
              //:default-value="defaultValues.managementForm"
              //@onChangeDefaultValue="changeSelectValue"
              //type="managementForm"
              //)
            .form__elem
              multiselect.custom-multiselect(
                v-model="fields.area"
                placeholder="Введите название района",
                :options="areasListData"
                :id="'area'"
                :multiple="false"
                :showLabels="false"
                :closeOnSelect="true"
                :allowEmpty="false"
                @select="changeSelectValue"
              )
                template(
                  slot="noOptions"
                ) Список пуст
                template(
                  slot="noResult"
                ) Ничего не найдено
            .form__elem
              input.input.input_full(
              placeholder="Поиск по названию"
              v-model="fields.campName"
              v-on:keyup="onKeyUpCampName()"
              )
            .form__elem.form__elem--align-right
              router-link.button.button_paint-main--transparent(
              :to="{name: 'AdminCampEditor', params: { id: 'create'}}"
              )
                .button__text Создать лагерь
        .admin-registry__table
          camp-scroll-fix-table(
          :tab-data="campsList"
          :tab-head="tableHead"
          @on-delete-camp="onDeleteCamp"
          @switch-change="onSwitchChange"
          )
        .admin-registry__pagination
          pagination(
          :total-count="paginationTotalCount"
          :page-limit="paginationPageLimit"
          :current-page="paginationCurrentPage"
          @on-button-click="onPaginationButtonClick"
          )
</template>

<script>
import {mapState, mapActions} from "vuex";
import AdminMixin from "../../mixins/admin-mixin.js";
import CampScrollFixTable from "../../components/CampScrollFixTable.vue";
import CampPartsScrollFixTable from "../../components/CampPartsScrollFixTable.vue";
import {CampTypeEnums} from "../../../../../const/index.js";
import SimpleSelectForm from "../../../../../components/simpleSelectForm/SimpleSelectForm";
import Multiselect from "vue-multiselect";
import Pagination from "../../../_manager/views/requests/components/Pagination";

export default {
  components: {
    Pagination,
    SimpleSelectForm,
    CampPartsScrollFixTable,
    CampScrollFixTable,
    Multiselect
  },
  name: "AdminCampsRegistry",
  mixins: [
    AdminMixin
  ],
  data() {
    return {
      tableHead: [
        {
          title: "Лагерь"
        },
        {
          title: "Тип лагеря"
        },
        {
          title: "Вместимость"
        },
        {
          title: "Директор"
        }
      ],
      campsList: [],
      rows: [],
      defaultValues: {
        managementForm: {
          value: null,
          text: "Все виды"
        },
        area: "Все районы"
      },
      fields: {
        area: "",
        campName: ""
      },
      typingInterval: null,
      paginationPageLimit: 30,
      paginationTotalCount: 0,
      paginationCurrentPage: 1
    };
  },
  computed: {
    ...mapState(["catalogue"]),
    managementFormsListData() {
      return JSON.parse(JSON.stringify(this.catalogue.managementForms));
    },
    areasListData() {
      return JSON.parse(JSON.stringify(this.catalogue.areas));
    }
  },
  methods: {
    ...mapActions(["getCamps", "deleteCamp", "updateCamp"]),
    setCampsList(camps, types) {
      const updatedCamps = camps.map(camp => {
        camp.type = types.prop[camp.type].text;
        if (camp.capacity === null) {
          camp.capacity = "-";
        }
        // camp.director_fio = this.setDirectorName(camp.director);
        camp.director_fio = camp.director;
        return camp;
      });
      return updatedCamps;
    },

    changeSelectValue(data, type) {
      this.fields[type] = data;
      this.filterTable();
    },
    filterTable(offset = 0) {
      this.$root.$emit("on-show-preloader");
      const filter = {
        params: {
          limit: this.paginationPageLimit,
          offset: offset * this.paginationPageLimit
        }
      };
      if (this.fields.area !== this.defaultValues.area) {
        filter.params.areas = this.fields.area;
      }
      filter.params.name = this.fields.campName;
      this.getCamps(filter).then(res => {
        this.paginationTotalCount = res.count;
        this.campsList = this.setCampsList(res.results, CampTypeEnums);
        this.$root.$emit("on-hide-preloader");
      });
    },

    switchChange(item) {
      setTimeout(() => {
        item.is_published = !item.is_published;
        this.updateCamp({
          id: item.id,
          data: {
            is_published: item.is_published
          }
        }).then(res => {
          if (res.status !== 200) {
            alert(res.status);
            item.is_published = !item.is_published;
          }
        });
      });
    },
    onSwitchChange(item) {
      if (item.is_published) {
        this.$root.$emit("onShowConfirmModal", {
          text: "При деактивации данного лагеря - он будет не доступен к просмотру на публичной части.",
          buttonConfirmText: "Продолжить",
          buttonCancelText: "Отмена",
          buttonConfirmFunc: {
            func: this.switchChange,
            params: [item]
          }
        });
      } else {
        this.switchChange(item);
      }
    },

    onDeleteCamp(camp) {
      this.$root.$emit("onShowConfirmModal", {
        text: "При удалении данного лагеря - все поданные заявки аннулируются.",
        buttonConfirmText: "Продолжить",
        buttonCancelText: "Отмена",
        buttonConfirmFunc: {
          func: this.deletion,
          params: [camp.id]
        }
      });
    },
    deletion(id) {
      this.deleteCamp(id).then(res => {
        if (res.status === 204) {
          const index = this.campsList.findIndex(item => {
            return item.id === id;
          });
          this.campsList.splice(index, 1);
        } else if (res.status === 400) {
          const errorText = "Ошибка!";
          this.$root.$emit("onShowErrorModal", {
            text: errorText
          });
        }
      });
    },

    onKeyUpCampName() {
      clearInterval(this.typingInterval);
      this.typingInterval = setInterval(() => {
        clearInterval(this.typingInterval);
        this.filterTable();
      }, 500);
    },
    setFields() {
      this.fields.area = this.defaultValues.area;
    },
    onPaginationButtonClick(button) {
      this.filterTable(button - 1);
      this.paginationCurrentPage = button;
    }
  },
  created() {
    this.$root.$emit("on-show-preloader");
  },
  mounted() {
    this.setFields();
    this.filterTable();
  }
};
</script>
